export const DASHBOARD_PATH = '/dashboard';

export const MY_CAMPAIGNS_PATH = '/campaigns';
export const MY_CAMPAIGN_DETAILS_PATH = `${MY_CAMPAIGNS_PATH}/:id`;
export const MY_CAMPAIGNS_HU_PATH = '/programs';

export const RCS_CAMPAIGNS_PATH = '/rcs-campaigns';
export const RCS_CAMPAIGN_DETAILS_PATH = `${RCS_CAMPAIGNS_PATH}/:id`;

export const CNP_CAMPAIGNS_PATH = '/cnp-campaigns';
export const CNP_CAMPAIGNS_HISTORY_PATH = `${CNP_CAMPAIGNS_PATH}/history`;
export const DECLINED_CNP_CAMPAIGNS_PATH = `${CNP_CAMPAIGNS_PATH}/declined`;
export const CNP_CAMPAIGN_DETAILS_PATH = `${CNP_CAMPAIGNS_PATH}/:id`;

export const CNP_RCS_CAMPAIGNS_PATH = '/rcs-cnp-campaigns';
export const CNP_RCS_CAMPAIGNS_HISTORY_PATH = `${CNP_RCS_CAMPAIGNS_PATH}/history`;
export const CNP_RCS_CAMPAIGN_DETAILS_PATH = `${CNP_RCS_CAMPAIGNS_PATH}/:id`;

export const WILDCARD_CAMPAIGN_DETAILS_PATH = '/wildcard-campaigns/:id';

export const BRANDS_PATH = '/brands';
export const BRAND_DETAILS_PATH = `/brands/:id`;

export const MY_CAMPAIGNS_DEFAULT_ENTRY = `${MY_CAMPAIGNS_PATH}?status=ACTIVE&provisional=false`;
export const CNP_CAMPAIGNS_DEFAULT_ENTRY = `${CNP_CAMPAIGNS_PATH}?status=ACTIVE&provisional=false`;
export const CNP_CAMPAIGNS_HISTORY_DEFAULT_ENTRY = `${CNP_CAMPAIGNS_HISTORY_PATH}?status=ACTIVE&provisional=false`;
export const DECLINED_CNP_CAMPAIGNS_DEFAULT_ENTRY = `${DECLINED_CNP_CAMPAIGNS_PATH}?status=ACTIVE&provisional=false`;
export const MY_CAMPAIGNS_HU_DEFAULT_ENTRY = `${MY_CAMPAIGNS_HU_PATH}?status=ACTIVE`;

export const BRANDS_DEFAULT_ENTRY = `${BRANDS_PATH}?status=ACTIVE`;

export const CAMPAIGN_REGISTRATION = '/campaign/create';
